import { render, staticRenderFns } from "./FaturasPendentes.vue?vue&type=template&id=4bf703f2&scoped=true"
import script from "./FaturasPendentes.vue?vue&type=script&lang=js"
export * from "./FaturasPendentes.vue?vue&type=script&lang=js"
import style0 from "./FaturasPendentes.vue?vue&type=style&index=0&id=4bf703f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf703f2",
  null
  
)

export default component.exports